import { hasStylesToRemove } from "@azu-business/editor-v3";
import { AibBlockLine } from "aic";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";

/**
 * Checks if a BlockLine (used in Titles and Footnotes) contains any Optional or Notes styles.
 * Checks all three text positions: left, center, and right.
 *
 * @template T - Content type (typically IEditorV3 or null)
 * @param line - The BlockLine to check for styles
 * @returns True if any position contains styles to remove, false otherwise
 */
export const hasStylesInBlockLine = <T>(line: AibBlockLine<T>): boolean => {
  const stylesToCheck = [...STYLES_TO_DELETE, ...STYLES_TO_CLEAN];

  return (
    hasStylesToRemove(line.left, stylesToCheck) ||
    hasStylesToRemove(line.center, stylesToCheck) ||
    hasStylesToRemove(line.right, stylesToCheck)
  );
};
